import { render } from "./importControls.vue?vue&type=template&id=3abd5f98&scoped=true&ts=true"
import script from "./importControls.vue?vue&type=script&lang=ts"
export * from "./importControls.vue?vue&type=script&lang=ts"

import "./importControls.vue?vue&type=style&index=0&id=3abd5f98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abd5f98"]])

export default __exports__